export const ADMIN_LOGIN_REQUEST = 'ADMIN_LOGIN_REQUEST'
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS'
export const ADMIN_LOGIN_FAIL = 'ADMIN_LOGIN_FAIL'
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT'

export const GET_ADMINS_REQUEST = 'GET_ADMINS_REQUEST'
export const GET_ADMINS_SUCCESS = 'GET_ADMINS_SUCCESS'
export const GET_ADMINS_FAIL = 'GET_ADMINS_FAIL'
export const GET_ADMINS_RESET = 'GET_ADMINS_RESET'

export const EDIT_ADMIN_REQUEST = 'EDIT_ADMIN_REQUEST'
export const EDIT_ADMIN_SUCCESS = 'EDIT_ADMIN_SUCCESS'
export const EDIT_ADMIN_FAIL = 'EDIT_ADMIN_FAIL'
export const EDIT_ADMIN_RESET = 'EDIT_ADMIN_RESET'

export const GENERATE_PASSWORD_ADMIN_REQUEST = 'GENERATE_PASSWORD_ADMIN_REQUEST'
export const GENERATE_PASSWORD_ADMIN_SUCCESS = 'GENERATE_PASSWORD_ADMIN_SUCCESS'
export const GENERATE_PASSWORD_ADMIN_FAIL = 'GENERATE_PASSWORD_ADMIN_FAIL'
export const GENERATE_PASSWORD_ADMIN_RESET = 'GENERATE_PASSWORD_ADMIN_RESET'

export const ADD_ADMIN_REQUEST = 'ADD_ADMIN_REQUEST'
export const ADD_ADMIN_SUCCESS = 'ADD_ADMIN_SUCCESS'
export const ADD_ADMIN_FAIL = 'ADD_ADMIN_FAIL'
export const ADD_ADMIN_RESET = 'ADD_ADMIN_RESET'
